import React from 'react';
import {
    CONTACT_PAGE_DROPDOWN_BUSINESS_UNIT,
    CONTACT_PAGE_DROPDOWN_ROLE,
    CONTACT_PAGE_DROPDOWN_SALES_ORG
} from '../../../configuration/contact-page';
import { Dropdown } from '../../../components/dropdown';
import { ILxsContactPageSearchBoxProps } from '../lxs-contact-page.data';

const SearchBox: React.FC<ILxsContactPageSearchBoxProps> = ({
    resources,
    CLASS_NAME,
    salesOrgs,
    businessUnits,
    roles,
    filters,
    onFilterChange
}) => {
    return (
        <div className={`msc-section-box ${CLASS_NAME}__search-box`}>
            <div className={`msc-section-box__body ${CLASS_NAME}__search-box__body`}>
                <fieldset className='msc-form__group'>
                    <Dropdown
                        id={CONTACT_PAGE_DROPDOWN_SALES_ORG}
                        value={filters.salesOrg}
                        label={resources.contactPageSalesOrgDropdownHeader}
                        options={salesOrgs}
                        placeholder={resources.contactPageDropdownPlaceholder}
                        onChange={(val: string) => onFilterChange('salesOrg', val)}
                        disabled={false}
                    />
                </fieldset>
                <fieldset className='msc-form__group'>
                    <Dropdown
                        id={CONTACT_PAGE_DROPDOWN_BUSINESS_UNIT}
                        value={filters.businessUnit}
                        label={resources.contactPageBusinessUnitDropdownHeader}
                        options={businessUnits}
                        placeholder={resources.contactPageDropdownPlaceholder}
                        onChange={(val: string) => onFilterChange('businessUnit', val)}
                        disabled={false}
                    />
                </fieldset>
                <fieldset className='msc-form__group'>
                    <Dropdown
                        id={CONTACT_PAGE_DROPDOWN_ROLE}
                        value={filters.role}
                        label={resources.contactPageRoleDropdownHeader}
                        options={roles}
                        placeholder={resources.contactPageDropdownPlaceholder}
                        onChange={(val: string) => onFilterChange('role', val)}
                        disabled={false}
                    />
                </fieldset>
            </div>
        </div>
    );
};

export default SearchBox;
